import React, { useState, useEffect } from 'react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { fetchMerchants } from '../../../redux/Loyalty';
import { Merchant, CustomersDropdownProps } from '../types';
import { DropdownContainer, DropdownButton } from './styles';

const CustomersDropdown: React.FC<CustomersDropdownProps> = ({ onOptionSelect }) => {
  const [selectedOption, setSelectedOption] = useState<string>('Merchants');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const { merchants } = useSelector((state: RootState) => state.loyalty);

  useEffect(() => {
    dispatch(fetchMerchants());
  }, [dispatch]);

  const handleOptionClick = (option: Merchant) => {
    setSelectedOption(option.username || option.name || 'Merchants');
    setIsOpen(false);
    onOptionSelect(option);
  };

  const menuItems: MenuProps['items'] = merchants.map((option) => ({
    key: String(option.id),
    label: option.username || option.name,
    onClick: () => handleOptionClick(option),
  }));

  return (
    <DropdownContainer>
      <Dropdown
        menu={{ items: menuItems }}
        trigger={['click']}
        open={isOpen}
        onOpenChange={setIsOpen}
        placement="bottomLeft"
      >
        <DropdownButton>
          <span>{selectedOption}</span>
          {isOpen ? <UpOutlined /> : <DownOutlined />}
        </DropdownButton>
      </Dropdown>
    </DropdownContainer>
  );
};

export default CustomersDropdown;
